export default "__VITE_ASSET__2a9ab9b7__"